const LOGO_URL = "/logo.png";

const SIZES = {
  xs: { box: "h-12", glow: "h-10 w-20 blur-lg opacity-60" },
  sm: { box: "h-14", glow: "h-12 w-24 blur-xl opacity-65" },
  md: { box: "h-20", glow: "h-16 w-32 blur-2xl opacity-70" },
  lg: { box: "h-24", glow: "h-20 w-40 blur-2xl opacity-75" },
};

const BRAND_GRADIENT = "linear-gradient(135deg, #C026D3 0%, #FF1F8B 50%, #FF4422 100%)";

export default function Logo({ size = "md" }) {
  const s = SIZES[size] || SIZES.md;

  return (
    <div className="inline-flex items-center" data-testid="brand-logo">
      <span
        className={`relative inline-flex items-center justify-center ${s.box}`}
        style={{ isolation: "isolate", aspectRatio: "1 / 1" }}
      >
        {/* Soft brand glow */}
        <span
          aria-hidden
          className={`absolute rounded-full ${s.glow}`}
          style={{ background: BRAND_GRADIENT, zIndex: 0 }}
        />

        {/* Gradient layer clipped to the logo silhouette via CSS mask */}
        <span
          aria-hidden
          className="absolute inset-0"
          style={{
            background: BRAND_GRADIENT,
            WebkitMaskImage: `url(${LOGO_URL})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain",
            maskImage: `url(${LOGO_URL})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
            zIndex: 1,
          }}
        />

        {/* Original logo on top — black pixels disappear via screen blend, white wordmark stays white */}
        <img
          src={LOGO_URL}
          alt="My Local"
          className="relative h-full w-auto object-contain pointer-events-none"
          style={{ mixBlendMode: "screen", zIndex: 2 }}
        />
      </span>
    </div>
  );
}
